var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { auth } from "../../helper/authDecorator";
import { UrlHelper } from '../../helper/UrlWrapper';
import { nameDict } from "../../constant/authCode";
import GLOBAL_VUE from '../../globalVue';
import QuotedPrice from '../../api/QuotedPrice';
import TakeStockService from '../../api/TakeStockService';
import AddDialog from "./components/GoodAdd.vue";
import Header from "./components/AddHeader.vue";
import TableHeaderToolTip from './components/TableHeaderToolTip.vue';
import ImportData from "./components/ImportData.vue";
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["SAVE"] = 1] = "SAVE";
    ESaveType[ESaveType["SAVE_PRINT"] = 2] = "SAVE_PRINT";
})(ESaveType || (ESaveType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 280;
        _this.data = [];
        _this.formData = {
            organ_id: '',
            depot_id: '',
            order_type: 1,
            order_mode: '',
            order_icomment: ''
        };
        _this.ImportTitle = {
            organ_name: '',
            depot_name: '',
            order_type_name: '日盘',
            stock_type_name: ''
        };
        _this.enumStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus.Add;
        _this.ESaveType = ESaveType;
        _this.from_system = 3;
        _this.orderid = '';
        _this.total = 0;
        _this.start = 0;
        _this.limit = 20;
        _this.dialogTableVisible = false;
        _this.dialogTableEditVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.emptyMoneyCanSubmit = false;
        _this.notAllEmptyFlag = true;
        _this.emptyFlag = true;
        _this.goods_format_ids = [];
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.formDataOrderModeWatch = function (newVal, oldVal) {
        var _this = this;
        if (newVal != 2 && this.formData.depot_id) {
            var params = {
                depot_id: this.formData.depot_id,
                limit: 0
            };
            if (newVal == 1) {
                this.formData.order_type = '';
                params['stock_type'] = 1;
            }
            else {
                this.formData.order_type = 1;
                params['order_type'] = this.formData.order_type;
            }
            if (this.handleStatus == 2) {
                return false;
            }
            this.takeStockService.getStockinitGoodslist(params).then(function (res) {
                if (res.data.success) {
                    _this.data = res.data.data || [];
                    _this.data.length && _this.data.forEach(function (item) {
                        if (item.purchase_unit_name === item.inventory_unit_name) {
                            item.purchase_inventory = 0;
                        }
                    });
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            if (this.handleStatus == 1) {
                this.data = [];
            }
        }
    };
    default_1.prototype.formDataOrderTypeWatch = function (newVal, oldVal) {
        var _this = this;
        if (this.formData.order_mode != 2 && this.formData.depot_id) {
            var params = {
                depot_id: this.formData.depot_id,
                order_type: newVal,
                limit: 0
            };
            if (this.formData.order_mode != 0) {
                return;
            }
            if (this.formData.order_mode == 1) {
                params['stock_type'] = 1;
            }
            if (this.handleStatus == 2) {
                return false;
            }
            this.takeStockService.getStockinitGoodslist(params).then(function (res) {
                if (res.data.success) {
                    _this.data = res.data.data || [];
                    _this.data.length && _this.data.forEach(function (item) {
                        if (item.purchase_unit_name === item.inventory_unit_name) {
                            item.purchase_inventory = 0;
                        }
                    });
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            if (this.handleStatus == 1) {
                this.data = [];
            }
        }
    };
    default_1.prototype.formDataDepotIdWatch = function (newVal, oldVal) {
        var _this = this;
        if (this.formData.order_mode !== '' && this.formData.order_mode != 2 && newVal) {
            var params = {
                depot_id: newVal,
                limit: 0
            };
            if (this.formData.order_mode === 0) {
                params['order_type'] = this.formData.order_type;
            }
            else {
                params['stock_type'] = 1;
            }
            if (this.handleStatus == 2) {
                return false;
            }
            this.takeStockService.getStockinitGoodslist(params).then(function (res) {
                if (res.data.success) {
                    _this.data = res.data.data;
                    _this.data.length && _this.data.forEach(function (item) {
                        if (item.purchase_unit_name === item.inventory_unit_name) {
                            item.purchase_inventory = 0;
                        }
                    });
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
        else {
            if (this.handleStatus == 1) {
                this.data = [];
            }
        }
    };
    default_1.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
        this.takeStockService = TakeStockService.getInstance();
        if (this.orderid) {
            this.getDetail();
        }
    };
    default_1.prototype.mounted = function () {
    };
    default_1.prototype.inputChange = function (row, key) {
        if (row[key]) {
            var value = row[key];
            if (value.indexOf('.') === 0) {
                value = '0' + value;
            }
            value = value.replace(/。/g, '.');
            value = value.replace(/[^\d.]/g, '');
            var dotIndex = value.indexOf('.');
            if (dotIndex !== -1) {
                var decimalPart = value.substring(dotIndex + 1).replace(/\./g, '');
                value = value.substring(0, dotIndex + 1) + decimalPart.substring(0, 4);
            }
            row[key] = value;
        }
    };
    default_1.prototype.updateData = function (updatedata) {
        var _this = this;
        this.data.forEach(function (item) {
            updatedata.forEach(function (i) {
                if (item.goods_format_code == i.goods_format_code) {
                    _this.$set(item, 'stock_inventory', i.inventory_stock);
                }
            });
        });
        this.$forceUpdate();
    };
    default_1.prototype.importAudit = function () {
        this.$refs.ImportData.showImportModal();
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
            edit: 1
        };
        this.takeStockService.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.data = data.order_detail;
            _this.data.length && _this.data.forEach(function (item) {
                if (item.purchase_unit_name === item.inventory_unit_name) {
                    item.purchase_inventory = 0;
                }
            });
            _this.total = res.data.total || 0;
            var goods_format_ids = (data.detail || []).map(function (good) {
                return good.goods_format_id;
            });
            _this.goods_format_ids = goods_format_ids || [];
            _this.formData = Object.assign({}, _this.formData, {
                depot_id: data.depot_id,
                organ_name: data.organ_name,
                depot_name: data.depot_name,
                order_icomment: data.order_icomment,
                organ_id: data.organ_id,
                out_depot_id: data.out_depot_id,
                out_depot_name: data.out_depot_name,
                order_code: data.order_code,
                order_mode_name: data.order_mode_name,
                order_mode: data.order_mode,
                order_type: data.order_type,
                order_type_name: data.order_type_name
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.save = function (saveType) {
        var _this = this;
        var formData = this.formData;
        if (!this.data || !this.data.length) {
            this.$message.warning("请添加货品");
            return;
        }
        if (this.handleStatus === EHanldeStatus.Add) {
            var data = this.data.map(function (item) {
                return {
                    goods_id: item.goods_id || '',
                    goods_format_id: item.goods_format_id || '',
                    order_detail_id: item.order_detail_id || 0,
                    purchase_unit_id: item.purchase_unit_id || '',
                    purchase_format: item.purchase_format || '',
                    inventory_unit_id: item.inventory_unit_id || '',
                    order_remaining_stock: item.order_remaining_stock || '',
                    purchase_inventory: item.purchase_inventory || '',
                    stock_inventory: item.stock_inventory || '',
                    inventory_stock: item.inventory_stock || '',
                    shortage_stock: item.shortage_stock || '',
                    overage_stock: item.overage_stock || '',
                    order_detail_icomment: item.order_detail_icomment || '',
                };
            });
            var params = __assign({}, formData, { order_detail: JSON.stringify(data) });
            this.takeStockService.addUpperwarehouse(params).then(function (res) {
                if (res.data.code == 3) {
                    var html = "<div>" + res.data.msg + "</div>";
                    _this.$confirm(html, '提示', {
                        dangerouslyUseHTMLString: true,
                        customClass: 'confirm',
                        confirmButtonText: '知道了',
                        showCancelButton: false,
                    }).catch(function (err) {
                        console.log(err);
                    });
                    return;
                }
                if (res.data.success) {
                    _this.$message.success("保存成功");
                    if (saveType == ESaveType.SAVE_PRINT) {
                        _this.mulPrint();
                    }
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
        else {
            var data = this.data.map(function (item) {
                return {
                    goods_id: item.goods_id || '',
                    goods_format_id: item.goods_format_id || '',
                    order_detail_id: item.order_detail_id || 0,
                    purchase_unit_id: item.purchase_unit_id || '',
                    purchase_format: item.purchase_format || '',
                    inventory_unit_id: item.inventory_unit_id || '',
                    order_remaining_stock: item.order_remaining_stock || '',
                    purchase_inventory: item.purchase_inventory,
                    stock_inventory: item.stock_inventory,
                    inventory_stock: item.inventory_stock || '',
                    shortage_stock: item.shortage_stock || '',
                    overage_stock: item.overage_stock || '',
                    order_detail_icomment: item.order_detail_icomment || '',
                };
            });
            var params = __assign({}, formData, { order_id: this.orderid, order_detail: JSON.stringify(data) });
            this.takeStockService.addUpperwarehouse(params).then(function (res) {
                if (res.data.code == 3) {
                    var html = "<div>" + res.data.msg + "</div>";
                    _this.$confirm(html, '提示', {
                        dangerouslyUseHTMLString: true,
                        customClass: 'confirm',
                        confirmButtonText: '知道了',
                        showCancelButton: false,
                    }).catch(function (err) {
                        console.log(err);
                    });
                    return;
                }
                if (res.data.success) {
                    _this.$message.success("保存成功");
                    if (saveType == ESaveType.SAVE_PRINT) {
                        _this.mulPrint();
                    }
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
    };
    default_1.prototype.mulPrint = function () {
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purBack");
        url = UrlHelper.addParam(url, 'order_id', this.orderid);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
    };
    default_1.prototype.orderChange = function () {
    };
    default_1.prototype.clientChange = function (formData) {
    };
    default_1.prototype.toAdd = function () {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Add && !this.formData.depot_id) {
            this.$message.warning("请选择仓库");
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                purchasers: this.formData.clientArray,
                depot_id: this.formData.depot_id
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            _this.data = res;
            _this.data.length && _this.data.forEach(function (item) {
                if (item.purchase_unit_name === item.inventory_unit_name) {
                    item.purchase_inventory = 0;
                }
            });
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Edit) {
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
        }, function (err) { });
    };
    default_1.prototype.pageChange = function (pager) {
    };
    default_1.prototype.calculateInventoryStock = function (row) {
        row.inventory_stock = +(row.purchase_inventory * row.purchase_format) + (+row.stock_inventory);
        row.inventory_stock = row.inventory_stock.toString() == 'NaN' ? '' : row.inventory_stock;
        return row.inventory_stock;
    };
    default_1.prototype.calculateShortageStock = function (row) {
        if (!row.purchase_inventory && row.purchase_inventory !== 0 || !row.stock_inventory && row.stock_inventory !== 0) {
            return '';
        }
        if (row.order_remaining_stock - row.inventory_stock >= 0) {
            row.shortage_stock = parseFloat((Math.abs(row.order_remaining_stock - row.inventory_stock)).toFixed(4));
            row.shortage_stock = row.shortage_stock.toString() == 'NaN' ? '' : row.shortage_stock;
            return row.shortage_stock;
        }
        else {
            row.shortage_stock = '';
            return '';
        }
    };
    default_1.prototype.calculateOverageStock = function (row) {
        if (!row.purchase_inventory && row.purchase_inventory !== 0 || !row.stock_inventory && row.stock_inventory !== 0) {
            return '';
        }
        if (row.order_remaining_stock - row.inventory_stock <= 0) {
            row.overage_stock = parseFloat((Math.abs(row.order_remaining_stock - row.inventory_stock)).toFixed(4));
            row.overage_stock = row.overage_stock.toString() == 'NaN' ? '' : row.overage_stock;
            return row.overage_stock;
        }
        else {
            row.overage_stock = '';
            return '';
        }
    };
    default_1.prototype.changeImportTitle = function (type, data) {
        this.ImportTitle[type] = data;
    };
    __decorate([
        Watch('formData.order_mode')
    ], default_1.prototype, "formDataOrderModeWatch", null);
    __decorate([
        Watch('formData.order_type')
    ], default_1.prototype, "formDataOrderTypeWatch", null);
    __decorate([
        Watch('formData.depot_id')
    ], default_1.prototype, "formDataDepotIdWatch", null);
    default_1 = __decorate([
        auth(nameDict["盘点"], true),
        Component({
            components: {
                'add-header': Header,
                TableHeaderToolTip: TableHeaderToolTip,
                ImportData: ImportData
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "采购数量*采购系数+库存数量",
                            placement: "bottom"
                        }
                    }, '合计实盘');
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
